/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloResolucionesFacturaciones from 'Infotrack@Modelos/smartStock/resolucionesFacturaciones';
import IResolucionesFacturaciones from 'Infotrack@Modelos/smartStock/resolucionesFacturaciones/entidades/resolucionesFacturaciones';

export default class ControladorModeloResolucionesFacturaciones {
    private modeloResolucionesFacturaciones: ModeloResolucionesFacturaciones;
    constructor() {
        this.modeloResolucionesFacturaciones = new ModeloResolucionesFacturaciones();
    }

    public async consultarResolucionesFacturaciones() {
        const {
            data: { Entidades },
        } = await this.modeloResolucionesFacturaciones.consultarResolucionesFacturaciones();
        return Entidades;
    }

    public async crearResolucionesFacturaciones(resolucionesFacturaciones: IResolucionesFacturaciones) {
        return this.modeloResolucionesFacturaciones.crearResolucionesFacturaciones(resolucionesFacturaciones);
    }

    public async editarResolucionesFacturaciones(resolucionesFacturaciones: IResolucionesFacturaciones) {
        return this.modeloResolucionesFacturaciones.editarResolucionesFacturaciones(resolucionesFacturaciones);
    }
    public async eliminarResolucionesFacturaciones(resolucionesFacturaciones: IResolucionesFacturaciones) {
        await this.modeloResolucionesFacturaciones.eliminarResolucionesFacturaciones(resolucionesFacturaciones);
    }

    public validarEntidad(resolucionesFacturaciones: IResolucionesFacturaciones): boolean {
        if (
            resolucionesFacturaciones.BodegaId === 0 ||
            resolucionesFacturaciones.DescripcionResolucionFacturacion === '0' ||
            resolucionesFacturaciones.FacturaInicio === 0 ||
            resolucionesFacturaciones.FacturaFin === 0 ||
            resolucionesFacturaciones.FacturaActual === 0 ||
            resolucionesFacturaciones.FechaInicio === '' ||
            resolucionesFacturaciones.FechaFin === '' ||
            resolucionesFacturaciones.FechaInicio === null ||
            resolucionesFacturaciones.FechaFin === null ||
            resolucionesFacturaciones.Estado === ''
        ) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
